import { Avatar, brandAvatarTint } from '@/components/ui/avatar';
import { MenuTrigger } from '@/components/ui/menu';
import { useAuth } from '@/contexts/auth-context';
import { Box, Button, Flex, Text } from '@chakra-ui/react';

import React from 'react';
import { NavArrowDown } from 'iconoir-react';

// Hovered, or holding its menu open: the switcher lifts a notch off the menu.
const RAISED_STATE = { bg: 'navDark.surfaceHoverBg', borderColor: 'navDark.surfaceHoverBorder' };

interface BrandSelectorTriggerProps {
  isCollapsed?: boolean;
}

const BrandSelectorTrigger: React.FC<BrandSelectorTriggerProps> = ({ isCollapsed = false }) => {
  const { user } = useAuth();
  const brand = user?.currentBrand;

  return (
    <MenuTrigger asChild>
      <Button
        variant="plain"
        w="full"
        h="auto"
        px={isCollapsed ? 0 : '8px'}
        pr={isCollapsed ? 0 : '10px'}
        py="7px"
        bg="navDark.surface"
        borderWidth="1px"
        borderColor="navDark.surfaceBorder"
        borderRadius="12px"
        display="flex"
        justifyContent={isCollapsed ? 'center' : 'space-between'}
        alignItems="center"
        transition="background-color 0.12s ease, border-color 0.12s ease"
        _hover={RAISED_STATE}
        _open={RAISED_STATE}
      >
        <Flex
          alignItems="center"
          gap="11px"
          justify={isCollapsed ? 'center' : 'flex-start'}
          minW={0}
          w={isCollapsed ? 'full' : 'auto'}
        >
          <Avatar
            src={brand?.imageUrl || undefined}
            name={brand?.name}
            w="34px"
            h="34px"
            rounded="10px"
            borderWidth="1px"
            borderColor="navDark.surfaceHoverBorder"
            flexShrink={0}
            {...brandAvatarTint}
          />
          {!isCollapsed && (
            <Text
              fontFamily="heading"
              fontSize="14px"
              fontWeight={700}
              lineHeight="1.15"
              color="navDark.textStrong"
              truncate
            >
              {brand?.name || 'Fluenceur'}
            </Text>
          )}
        </Flex>

        {!isCollapsed && (
          <Box
            as="span"
            display="inline-flex"
            alignItems="center"
            color="navDark.textSubtle"
            aria-hidden
          >
            <NavArrowDown width={16} height={16} />
          </Box>
        )}
      </Button>
    </MenuTrigger>
  );
};

export default BrandSelectorTrigger;
